import * as actionTypes from './action-types';

const STORAGE_KEY = 'accuracyRankingFilterSettings';

export const DEFAULT_ACCURACY_RANKING_FILTERS = {
  location_id: null,
  turbine_data_id: null,
  metric_id: null,
  compare_metric_id: null,
  compare_turbine_data_id: null,
  from: null,
  to: null
};

const loadStoredAccuracyRanking = () => {
  if (typeof window === 'undefined') {
    return { filters: { ...DEFAULT_ACCURACY_RANKING_FILTERS }, hasApplied: false };
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { filters: { ...DEFAULT_ACCURACY_RANKING_FILTERS }, hasApplied: false };
    }

    const parsed = JSON.parse(raw);

    return {
      filters: {
        location_id: parsed.location_id ?? null,
        turbine_data_id: parsed.turbine_data_id ?? null,
        metric_id: parsed.metric_id ?? null,
        compare_metric_id: parsed.compare_metric_id ?? null,
        compare_turbine_data_id: parsed.compare_turbine_data_id ?? null,
        from: parsed.from ?? null,
        to: parsed.to ?? null
      },
      hasApplied: Boolean(parsed.hasApplied)
    };
  } catch {
    return { filters: { ...DEFAULT_ACCURACY_RANKING_FILTERS }, hasApplied: false };
  }
};

const persistAccuracyRanking = (filters, hasApplied) => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...filters,
        hasApplied
      })
    );
  } catch {
    // ignore quota / private mode errors
  }
};

const storedAccuracyRanking = loadStoredAccuracyRanking();

export const initialState = {
  filters: storedAccuracyRanking.filters,
  hasApplied: storedAccuracyRanking.hasApplied
};

const accuracyRankingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ACCURACY_RANKING_FILTERS: {
      const next = {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };
      persistAccuracyRanking(next.filters, next.hasApplied);
      return next;
    }
    case actionTypes.SET_ACCURACY_RANKING_HAS_APPLIED: {
      const next = {
        ...state,
        hasApplied: action.payload
      };
      persistAccuracyRanking(next.filters, next.hasApplied);
      return next;
    }
    default:
      return state;
  }
};

export default accuracyRankingReducer;
